export enum AreaModelRotation {
    Random = "Random",
    Uniform = "Uniform"
}